<footer  class="max-w-7xl  mx-auto rounded-t-xl  bg-gray-100 text-gray-500" style="margin-top: 5rem">
    <div class="mx-auto w-full max-w-[90%] py-12">

        <ng-container *ngIf="metaData?.footer?.visible?.value">
            <div *ngIf="hasContactData"
                class="footer-contact-grid flex flex-wrap justify-center mb-8 max-w-6xl mx-auto">
                <!-- Address -->
                <div class="space-y-3" *ngIf="metaData.contact.fields.address.visible">
                    <h3 class="text-base font-medium text-gray-700">
                        {{ "words.address" | translate }}
                    </h3>
                    <p class="text-sm text-gray-500 capitalize">
                        {{ metaData.contact.fields.address.value }}
                    </p>
                </div>

                <!-- Contact Form -->
                <div class="space-y-3" *ngIf="metaData.contact.fields.contactForm.visible">
                    <h3 class="text-base font-medium text-gray-700">
                        {{ "words.contact-form" | translate }}
                    </h3>
                    <a [href]="metaData.contact.fields.contactForm.value" target="_blank"
                        class="text-sm block hover:text-gray-700 text-gray-500 transition">
                        {{ "header.action.send-message" | translate }}
                        <i class="fas fa-arrow-right ml-1 text-xs"></i>
                    </a>
                </div>

                <!-- Email -->
                <div class="space-y-3" *ngIf="metaData.contact.fields.email.visible">
                    <h3 class="text-base font-medium text-gray-700">
                        {{ "words.email" | translate }}
                    </h3>
                    <div class="text-sm text-gray-500">
                        <a [href]="'mailto:' + metaData.contact.fields.email.value" target="_blank"
                            class="block hover:text-gray-700 text-gray-500 transition">{{
                            metaData.contact.fields.email.value }}</a>
                    </div>
                </div>

                <!-- Phone -->
                <div class="space-y-3" *ngIf="metaData.contact.fields.phone.visible">
                    <h3 class="text-base font-medium text-gray-700">
                        {{ "words.phone" | translate }}
                    </h3>
                    <div class="text-sm text-gray-500">
                        <a [href]="'tel:' + metaData.contact.fields.phone.value" target="_blank"
                            class="block hover:text-gray-700 text-gray-500 transition">
                            {{ metaData.contact.fields.phone.value }}
                        </a>
                    </div>
                </div>

                <!-- Website -->
                <div class="space-y-3" *ngIf="metaData.contact.fields.website.visible">
                    <h3 class="text-base font-medium text-gray-700">
                        {{ "dashboard.website" | translate }}
                    </h3>
                    <div class="text-sm">
                        <a [href]="metaData.contact.fields.website.value" target="_blank"
                            class="block hover:text-gray-700 transition text-gray-500">
                            {{ metaData.contact.fields.website.value }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- Iconos redes oculto dentro de la grid -->
            <div class="container-icons flex-col items-center justify-center mb-8"
                *ngIf="(mainSocialIcons && mainSocialIcons.length > 0) || (dropdownSocialIcons && dropdownSocialIcons.length > 0)">
                <div class="flex justify-center items-center flex-wrap gap-3">
                    <!-- Iconos principales (primeros 5) -->
                    <ng-container *ngFor="let icon of mainSocialIcons">
                        <a [href]="icon.url" target="_blank"
                            class="w-9 h-9 flex items-center justify-center bg-white bg-opacity-50 rounded-full border border-gray-200 hover:bg-gray-200 transition">
                            <i [class]="icon.classes"></i>
                        </a>
                    </ng-container>

                    <!-- Dropdown solo si hay más de 5 iconos -->
                    <div class="relative" *ngIf="dropdownSocialIcons.length > 0">
                        <button
                            class="w-9 h-9 flex items-center justify-center bg-white bg-opacity-50 rounded-full border border-gray-200 hover:bg-gray-200 transition dropdown-button"
                            (click)="toggleDropdown($event)">
                            <i class="fas fa-ellipsis-h text-gray-600 text-sm"></i>
                        </button>

                        <!-- Menú desplegable -->
                        <div class="dropdown-menu absolute flex-wrap gap-2 p-3 justify-center bg-white rounded-lg shadow-xl w-64 right-0 bottom-full mb-2"
                            [class.show]="isDropdownOpen" (click)="onDropdownClick($event)">
                            <ng-container *ngFor="let icon of dropdownSocialIcons">
                                <a [href]="icon.url" target="_blank"
                                    class="w-9 h-9 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition">
                                    <i [class]="icon.classes"></i>
                                </a>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sec. legal -->
            <div class="text-center" [ngClass]="{
    'border-t border-gray-200 pt-6':
      metaData.footer.fields.legalNotice?.visible ||
      metaData.footer.fields.privacyPolicy?.visible ||
      metaData.footer.fields.termsAndConditions?.visible
  }">

                <div *ngIf="metaData.footer.fields.legalNotice?.visible || metaData.footer.fields.privacyPolicy?.visible || metaData.footer.fields.termsAndConditions?.visible"
                    class="flex flex-wrap justify-center gap-3 mb-2 text-sm">
                    <div *ngIf="metaData.footer.fields.legalNotice.visible">
                        <a [href]="metaData.footer.fields.legalNotice.value" target="_blank"
                            class="hover:text-gray-700 text-gray-700 text-base transition">{{ "words.legal-msg" |
                            translate
                            }}
                        </a>
                    </div>
                    <div>
                        <span *ngIf="metaData.footer.fields.legalNotice.visible" class="text-gray-300 pr-2">|</span>
                        <a *ngIf="metaData.footer.fields.privacyPolicy.visible"
                            [href]="metaData.footer.fields.privacyPolicy.value" target="_blank"
                            class="hover:text-gray-700 text-gray-700 text-base transition">{{ "words.privacy-policy" |
                            translate }}
                        </a>
                    </div>
                    <div *ngIf="metaData.footer.fields.termsAndConditions.visible">
                        <span *ngIf="metaData.footer.fields.privacyPolicy.visible" class="text-gray-300 pr-2">|</span>
                        <a [href]="metaData.footer.fields.termsAndConditions.value" target="_blank"
                            class="hover:text-gray-700 text-gray-700 text-base transition">{{ "words.terms-of-service" |
                            translate }}</a>
                    </div>
                </div>

            </div>
        </ng-container>
        <div class="text-sm text-gray-500 text-center">
            © {{ today | date : "yyyy" }} {{ company.experience.name }}
            {{ "words.by" | translate }} {{ company.name }}.
            {{ "words.all-rights-reserved" | translate }}.
        </div>

    </div>
</footer>